import React, { useEffect } from 'react';
import { bindActionCreators } from 'redux';
import { withRouter } from 'react-router-dom';
import { connect } from 'react-redux';
import { withTranslation } from 'react-i18next';
import _ from 'lodash';
import { UserActions } from '../../../store/actions/users';

import './ChannelFacebookMessenger.scss';

import Footer from '../../Footer2/index';
import { BotsCreators } from '../../../store/actions/bots';
import { ChannelId } from '../../../util/channels';
import ChannelFacebookMessengerLogin from './Components/FacebookMessenger/ChannelFacebookMessengerLogin';
import ChannelFacebookMessengerContent from './Components/FacebookMessenger/ChannelFacebookMessengerContent';

/**
 * Component for edit options for Facebook Messenger for user pages with the current bot
 *
 * @param {*} props
 * @returns
 */
const ChannelFacebookMessenger = (props) => {
  const { i18n, match, bot, retrieveBotRequest, facebookAuth, user } = props;
  const { botid } = match.params;

  /**
   * Called when component is created for retrieve the bot info
   */
  useEffect(() => {
    if (_.isEmpty(bot)) {
      retrieveBotRequest(botid);
    }
  }, []);

  /**
   * Get facebook messenger channel data
   * @returns {object} facebook messenger channel data object or undefined if user not config this channel
   */
  const getChannelData = () => {
    const channel = _.find(bot.channels, (ch) => {
      if (ch.channelId === ChannelId.FacebookMessenger) {
        return ch;
      }
    });
    return channel;
  };

  /**
   * Render container content for this component
   */
  const renderContainerContent = () => {
    const currentChannel = getChannelData();
    if (_.isEmpty(bot)) {
      return false;
    }

    return !currentChannel && facebookAuth.accessToken === '' ? (
      <ChannelFacebookMessengerLogin user={user} />
    ) : (
      <ChannelFacebookMessengerContent channelData={currentChannel} />
    );
  };

  return (
    <div className="channelWhats-container" style={{ height: '92vh' }}>
      <div className="col-md-5 mt-5">
        <span className="channel-title">
          {i18n.t('Configurar Facebook Messenger')}
        </span>
        <div className="channel-facebook-container">
          {renderContainerContent()}
        </div>
      </div>
      <Footer />
    </div>
  );
};

const mapStateToProps = (state) => {
  return {
    bot: state.bots.bot,
    facebookAuth: state.facebookMessenger.facebookAuth,
    user: state.users.signedUser,
  };
};

const mapDispatchToProps = (dispatch) => {
  return bindActionCreators({ ...BotsCreators, ...UserActions }, dispatch);
};

export default withRouter(
  connect(
    mapStateToProps,
    mapDispatchToProps
  )(withTranslation()(ChannelFacebookMessenger))
);
